import { DropDownList, FieldSettingsModel } from '@syncfusion/ej2-react-dropdowns';
import { DataManager, Query, WebApiAdaptor } from '@syncfusion/ej2-data';
import { store } from '../store';
import Cookies from 'js-cookie';
const ORG_GROUP_FIELD = 'organization_code';

const GetBackendUrlForGlobalFunctions = () => {
  const state = store.getState();
  return state.search.backEndUrl;
};
const getOrgUtils = () => require('./orgCodeMap') as typeof import('./orgCodeMap');

const attachOrgCode = (e: any) => {
  const list = Array.isArray(e?.result) ? e.result : e?.result?.result;
  if (!Array.isArray(list)) return;

  const { getOrgCodeMapSync, getSelectedOrgIds } = getOrgUtils();
  const map = getOrgCodeMapSync();
  const selectedIds = getSelectedOrgIds();
  if (selectedIds.length > 0) {
    for (let i = list.length - 1; i >= 0; i--) {
      const orgId = list[i]?.organization_id;
      if (orgId != null && !selectedIds.includes(Number(orgId))) {
        list.splice(i, 1);
      }
    }
  }
  list.forEach((item: any) => {
    if (item && item.organization_id != null) {
      item[ORG_GROUP_FIELD] =
        map[String(item.organization_id)] ?? String(item.organization_id);
    }
  });
  list.sort((a: any, b: any) =>
    String(a?.[ORG_GROUP_FIELD] ?? '').localeCompare(String(b?.[ORG_GROUP_FIELD] ?? ''))
  );
};

export const getParamsDD = (
  fields: FieldSettingsModel,
  value: string | undefined,
  api: string,
  isReturnValu?: boolean,
  islabel?: boolean,
  groupByOrg?: boolean
) => {
  let theElement: any;
  let theObj: any;
  const token = Cookies.get('token');

  const theEditParams = {
    create: () => {
      theElement = document.createElement('input');
      return theElement;
    },
    destroy: () => {
      theObj && theObj.destroy();
    },
    read: () => (isReturnValu ? theObj?.value : theObj?.text),
    write: (args: any) => {
  const url = GetBackendUrlForGlobalFunctions() + api;
  const dataSource = new DataManager({
    adaptor: new WebApiAdaptor(),
    crossDomain: true,
    url,
    headers: [{ Authorization: `Bearer ${Cookies.get('token')}`, contentType: 'application/json' }],
  });

  const initialValue = islabel
    ? args.rowData[`label`]?.trim()
    : args.rowData[`${value}`]?.trim();

  theObj = new DropDownList({
    change: () => {},
    dataSource: [],
    fields: groupByOrg ? { ...fields, groupBy: ORG_GROUP_FIELD } : fields,
    floatLabelType: 'Never',
    allowFiltering: true,
  });
  theObj.appendTo(theElement);

  const current = theObj;
  const load = async () => {
    if (groupByOrg) await getOrgUtils().preloadOrgCodeMap();
    const res: any = await dataSource.executeQuery(new Query());
    const list = Array.isArray(res?.result) ? res.result : [];
    if (groupByOrg) attachOrgCode({ result: list });
    if (theObj !== current || current.isDestroyed) return;
    current.dataSource = list;
    if (initialValue) current.value = initialValue;
  };
  load().catch(() => {});
},
  };
  return theEditParams;
};
